import type { Slot } from '../types'
import { useUploadFile } from '../hooks/use-upload-file'
import { useDeleteFile } from '../hooks/use-delete-file'
import { EvidenceSlotCard } from '@/shared/components/evidence/evidence-slot-card'
import { checkSessionCopies } from '@/shared/lib/evidence/session-api'

interface SlotCardProps {
  slot: Slot
  token: string
  index: number
  error?: string
  isDemo?: boolean
}

/**
 * The Upload Evidence page's slot card - the shared `EvidenceSlotCard` wired to
 * this page's token-based upload/delete mutations (which keep the session query
 * cache in sync). Delete is enabled here; the consumer claim view renders the
 * same card without it (WPS-138 #6).
 */
export function SlotCard({ slot, token, index, error, isDemo }: SlotCardProps) {
  const uploadFile = useUploadFile(token, isDemo)
  const deleteFile = useDeleteFile(token, isDemo)

  return (
    <EvidenceSlotCard
      slot={slot}
      index={index}
      error={error}
      canDelete
      uploadFn={uploadFile.mutateAsync}
      deleteFn={deleteFile.mutateAsync}
      checkCopies={
        isDemo ? undefined : (hashes) => checkSessionCopies(token, slot.id, hashes)
      }
    />
  )
}
